import React, { useEffect, useState } from "react";
import axios from "api/baseurl";
import { useParams } from "react-router-dom";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, Tabs, Tab } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { toast } from "react-toastify"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";
import { Grid } from "@mui/material";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useNavigate } from 'react-router-dom';

const CustomerProfileDetails = () => {
  const { id } = useParams();
  const {name } = useParams();
    const{customerid}=useParams();
    const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
  const [selectedId, setSelectedId] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [deviceDetails, setDeviceDetails] = useState(null);
  const [chargingOutlets, setChargingOutlets] = useState([]);
  const [components, setComponents] = useState([]);
  const [monitoring, setMonitoring] = useState([]);
  const [openDelearModal, setOpenDelearModal] = useState(false);
  const [selectedDelearId, setSelectedDelearId] = useState(null);
  const [selectedDelearName, setSelectedDelearName] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
    const [installationAuditData, setInstallationAuditData] = useState([]);
  const [customerId, setCustomerId] = useState(null);

const navigate = useNavigate();

  // useEffect(() => {
    const fetchDelearDetails = async () => {
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        if (!token) throw new Error("Authentication token not found.");

        const response = await axios.get(`/api/Customerprofile/getByUserId/${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Raw Device Details Response:", response.data);
        if (response.status === 200) {
            const decryptedData = decryptBody(response.data, secretKey);
            console.log("Decrypted:", decryptedData);
      
            if (Array.isArray(decryptedData) && decryptedData.length > 0) {
              setDeviceDetails(decryptedData);
               setCustomerId(decryptedData[0].customerId);
            } else {
              setDeviceDetails([]); 
            }
          }
      } catch (error) {
        console.error("Error fetching dealers:", error);
      } finally {
        setLoading(false);
      }
    };
    
const fetchInstallationAudit = async () => {
  try {
    const secretKey = await fetchSecretKey();
    const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    if (!token) throw new Error("Authentication token not found.");

    const response = await axios.get(`/api/installationaudit/customerid=${customerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("Raw InstallationAudit Response:", response.data); // Log raw response

    if (response.status === 200) {
      const decryptedData = decryptBody(response.data, secretKey);
      setInstallationAuditData(decryptedData || []);
      console.log("Decrypted InstallationAudit Response:", decryptedData);
    }
  } catch (error) {
    console.error("Error fetching installation audit details:", error);

    if (error.response && error.response.status === 404) {
      toast.warning("No installation audit found for this customer.");
      setInstallationAuditData([]); 
    } else {
      toast.error("Failed to fetch installation audit details.");
    }
  } finally {
    setLoading(false);
  }
};

    const fetchChargingOutlets = async () => {
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        if (!token) throw new Error("Authentication token not found.");

        const response = await axios.get(`/api/customerdevicemapping/customerid=${customerId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Raw customerdevicemapping Response:", response.data); 

        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          setChargingOutlets(decryptedData || []);
          console.log("Raw customerdevicemapping Response:", decryptedData);

        }
      } catch (error) {
        console.error("Error fetching Dealer details:", error);
    
        if (error.response && error.response.status === 404) {
          toast.warning("No device mapping found for this customer.");
          setChargingOutlets([]); 
        } else {
          // toast.error("Failed to fetch Device details.");
        }
      } finally {
        setLoading(false);
      }
    };

    const fetchComponents = async () => {
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        if (!token) throw new Error("Authentication token not found.");

        const response = await axios.get(`/api/devicecomponent/deviceid=${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Raw Components Response:", response.data); 

        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          setComponents(decryptedData || []);
        }
      } catch (error) {
        console.error("Error fetching Transaction Details:", error);
        toast.error("Failed to fetch Transaction Details.");
      } finally {
        setLoading(false); 
      }
    };
    const fetchMonitoring = async () => {
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        if (!token) throw new Error("Authentication token not found.");

        const response = await axios.get(`/api/diagnostics/deviceId=${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Raw Components Response:", response.data); // Log raw response

        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          setMonitoring(decryptedData || []);
        }
      } catch (error) {
        console.error("Error fetching Financial Details:", error);
        toast.error("Failed to fetch  Financial Details.");
      } finally {
        setLoading(false); 
      }
    };

    // const fetchData = async () => {
    //     setLoading(true); 
    //     // await Promise.all([fetchDelearDetails(), fetchChargingOutlets(), fetchComponents(),fetchMonitoring()]);
    //             await Promise.all([fetchDelearDetails(), fetchChargingOutlets()]);

    //     setLoading(false); 
    //   };
    
    //   fetchData();
    // }, [id]);
    
   useEffect(() => {
  fetchDelearDetails();
}, []);
useEffect(() => {
  if (customerId) {
    fetchInstallationAudit(customerId);
    fetchChargingOutlets(customerId);
  }
}, [customerId]); // run when customerId is updated

 const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const dotPositions = [
  { top: "5%", left: "50%" },
  { top: "20%", left: "80%" },
  { top: "50%", left: "95%" },
  { top: "80%", left: "80%" },
  { top: "95%", left: "50%" },
  { top: "80%", left: "20%" },
  { top: "50%", left: "5%" },
  { top: "20%", left: "20%" },
];
const handleOpenDelearModal = () => {
    setSelectedDelearId(id);
    setSelectedDelearName(name);

    setOpenDelearModal(true);
  };
  
  const handleCloseDelearModal = () => {
    setOpenDelearModal(false);
    setSelectedDelearId(null);
    setSelectedDelearName(null);
    fetchDelearDetails();
    fetchChargingOutlets();
  };
  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  
      const encryptedData = encryptBody({ id: selectedId }, secretKey);
  
      const response = await axios.post("/api/customerdevicemapping/delete", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });
  
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        if (!decryptedResponse || !decryptedResponse.id) {
          throw new Error("Decryption failed or invalid response.");
        }
  
        toast.success(decryptedResponse.message || "Customer And Device Mapped deleted successfully!");
        setDeleteModal(false);
        setOpenDeleteModal(false); // Ensure you have this state for delete modal
        fetchDelearDetails();
        fetchChargingOutlets();
            }
    } catch (error) {
      toast.error(error.message || "Failed to delete device type.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (id) => {
    setSelectedDeviceId(id);
    setModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedDeviceId(null);
  };
  const openImageInNewTab = (base64Data, imageMeta) => {
  const metaParts = imageMeta.split(",");
  const mimeType = metaParts[1]?.trim() || "image/png"; // e.g., "image/png"

  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) {
      byteNumbers[j] = slice.charCodeAt(j);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: mimeType });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
};
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80, 
              height: 80, 
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8, 
                  height: 8, 
                  borderRadius: "50%",
                  backgroundColor:"#2e7faeff",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
    <Card sx={{ padding: 4, width: "90%", margin: "auto" }}>
      <MDTypography variant="h5" textAlign="center" color="success.main">
        Customer Details
      </MDTypography>
      {deviceDetails && deviceDetails.length > 0 ? (
    <MDBox sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
      {deviceDetails.map((dealer, index) => {
        const standard = dealer.standardFieldValues || {};
        const custom = dealer.customFieldValues || {};
        const customFields = Object.entries(custom);

        const leftFields = [
          ["Customer Type", dealer.customerType || "-"],
          ["Name", dealer.accountBio?.name || "-"],
          ["Email", dealer.accountBio?.email || "-"],
          ["Contact", dealer.accountBio?.contact || "-"],
        ];

        const middleFields = [
          ["Address", dealer.accountBio?.address || "-"],
          ["City", dealer.accountBio?.city || "-"],
          ["State", dealer.accountBio?.state || "-"],
          ["Pincode", dealer.accountBio?.pin || "-"],
          ["Country", dealer.accountBio?.country || "-"],
        ];

        const rightFields = [
          ["GST", dealer.accountBio?.gstin || "-"],
          ["PAN", dealer.accountBio?.pan || "-"],
          ["TAN", dealer.accountBio?.tan || "-"],
          ["Latitude", dealer.accountBio?.latitude || "-"],
          ["Longitude", dealer.accountBio?.longitude || "-"],
        ];

        return (
          <Box
            key={index}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
              border: "1px solid #ccc",
              borderRadius: 2,
              padding: 2,
              backgroundColor: "#f9f9f9",
            }}
          >
            {/* Left Section */}
            <Box sx={{ width: "30%", display: "flex", flexDirection: "column", gap: 1 }}>
              {leftFields.map(([key, value]) => (
                <Typography variant="body2" fontSize={13} key={key}>
                  <strong>{key}:</strong> {value}
                </Typography>
              ))}
                {middleFields.map(([key, value]) => (
                <Typography variant="body2" fontSize={13} key={key}>
                  <strong>{key}:</strong> {value}
                </Typography>
              ))}
              {/* {customFields.map(([key, value]) => (
                <Typography
                  variant="body2"
                  fontSize={13}
                  key={key}
                  sx={{ textTransform: "capitalize" }}
                >
                  <strong>{key.replace(/_/g, " ")}:</strong> {value}
                </Typography>
              ))} */}
            </Box>

            {/* Middle Section */}
            <Box sx={{ width: "30%", display: "flex", flexDirection: "column", gap: 1 }}>
            {rightFields.map(([key, value]) => (
                <Typography variant="body2" fontSize={13} key={key}>
                  <strong>{key}:</strong> {value}
                </Typography>
              ))}
            </Box>

            {/* Right Section */}
            <Box sx={{ width: "30%", display: "flex", flexDirection: "column", gap: 1 }}>
            {customFields.map(([key, value]) => (
                <Typography
                  variant="body2"
                  fontSize={13}
                  key={key}
                  sx={{ textTransform: "capitalize" }}
                >
                  <strong>{key.replace(/_/g, " ")}:</strong> {value}
                </Typography>
              ))}
             
            </Box>
          </Box>
        );
      })}
    </MDBox>
  ) : (
    <MDTypography textAlign="center" sx={{ fontSize: "16px", mt: 12 }}>
      No data available
    </MDTypography>
  )}

      <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} sx={{ mt: 12 }}>
      <Tab label="Hub Details" sx={{ fontWeight: "bold" }} />
            <Tab label="Installation Audit" sx={{ fontWeight: "bold" }} />

  <Tab label="Transaction Details" sx={{ fontWeight: "bold" }} />
  <Tab label="Financial Details" sx={{ fontWeight: "bold" }} />
      </Tabs>

      {tabValue === 0 && (
      <MDBox mt={4} display="flex" justifyContent="center">
       
          <MDBox>
       
        <TableContainer
        
    component={Card}
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "150px", // Ensures a minimum height
      height: "auto", // Adjusts based on content
      padding: "16px",
    }}
  >   
      {/* <MDButton
    size="small"
    color="success"
    onClick={() => handleOpenDelearModal()}
  >
    Map Hub
  </MDButton>  */}
          <Table sx={{ mt: 6 }}>
            <TableHead>
            <TableRow sx={{ backgroundColor:"#2e7faeff"  }}> {/* Success Green Color */}
                  <TableCell align="center" sx={{ fontSize: "15px",fontWeight: "bold", color: "white",border: "1px solid #ddd" ,width: "350px" }}>Hub Name</TableCell>
                  <TableCell align="center" sx={{ fontSize: "15px",fontWeight: "bold", color: "white",border: "1px solid #ddd" ,width: "350px" }}>Hub Code</TableCell>
                  <TableCell align="center" sx={{ fontSize: "15px",fontWeight: "bold", color: "white",border: "1px solid #ddd" ,width: "350px" }}>Device Type</TableCell>

                  {/* <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd"  ,width: "350px"}}>Actions</TableCell> */}

                </TableRow>
          
           
            <TableBody>
              {chargingOutlets.length > 0 ? (
                chargingOutlets.map((item, index) => (
                  <TableRow key={index}>
<TableCell
  sx={{ border: "1px solid #ddd", fontSize: "15px", cursor: "pointer" }}
  onClick={() => navigate(`/DeviceDetailsModal/${item.dev?.id}`)}
>
  {item.dev?.devicename}
</TableCell>
<TableCell
  sx={{ border: "1px solid #ddd", fontSize: "15px", }}
>
  {item.dev?.deviceCode}
</TableCell>
<TableCell
  sx={{ border: "1px solid #ddd", fontSize: "15px",}}
>
  {item.dev?.devicetype}
</TableCell>


 {/* <TableCell sx={{ textAlign: "center",border: "1px solid #ddd" }}>
               
                <IconButton
                  color="default"
                  onClick={() => handleOpenDeleteModal(item.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">No data available</TableCell>
                </TableRow>
              )}
            </TableBody>
            </TableHead>
          </Table>
        </TableContainer>
          </MDBox>
          {/* <DeviceDetailsModal
  open={modalOpen}
  onClose={handleCloseModal}
  deviceId={selectedDeviceId}
/> */}
  </MDBox>
      )}
 {tabValue === 1 && (
      <MDBox mt={4} display="flex" justifyContent="center">
       
          <MDBox>
       
        <TableContainer
        
    component={Card}
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "150px", // Ensures a minimum height
      height: "auto", // Adjusts based on content
      padding: "16px",
    }}
  >   
      {/* <MDButton
    size="small"
    color="success"
   onClick={(event) => {
  // event.stopPropagation();
  navigate(`/createinstallationaudit/${id}`);
}}
  >
    Create Installation Audit
  </MDButton>  */}
          <Table sx={{ mt: 6 }}>
            <TableHead>
            <TableRow sx={{backgroundColor:"#2e7faeff"   }}> {/* Success Green Color */}
                  <TableCell align="center" sx={{ fontSize: "15px",fontWeight: "bold", color: "white",border: "1px solid #ddd" ,width: "350px" }}>Date Time</TableCell>
                  <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd"  ,width: "350px"}}>Description</TableCell>
                 <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd"  ,width: "350px"}}>Document</TableCell>
                                  {/* <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd"  ,width: "350px"}}>Actions</TableCell> */}



                </TableRow>
          
           
            <TableBody>
              {installationAuditData.length > 0 ? (
                installationAuditData.map((item, index) => (
                  <TableRow key={index}>
<TableCell
  sx={{ border: "1px solid #ddd", fontSize: "15px"}}
>
  {item.datetime}
</TableCell>
<TableCell
  sx={{ border: "1px solid #ddd", fontSize: "15px"}}
>
  {item.description}
</TableCell>
<TableCell sx={{ border: "1px solid #ddd", fontSize: "15px", textAlign: "center" }}>
  {item.image ? (
    <button
      onClick={() => openImageInNewTab(item.image, item.imageMeta)}
      style={{
        background: "none",
        border: "none",
        color: "#1976d2",
        textDecoration: "underline",
        cursor: "pointer"
      }}
    >
      View Image
    </button>
  ) : (
    "No Image"
  )}
</TableCell>



 {/* <TableCell sx={{ textAlign: "center",border: "1px solid #ddd" }}>
               
                <IconButton
                  color="default"
                  onClick={() => handleOpenDeleteModal1(item.id)}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">No data available</TableCell>
                </TableRow>
              )}
            </TableBody>
            </TableHead>
          </Table>
        </TableContainer>
          </MDBox>
          {/* <DeviceDetailsModal
  open={modalOpen}
  onClose={handleCloseModal}
  deviceId={selectedDeviceId}
/> */}
  </MDBox>
      )}
      {tabValue === 2 && (
    <MDBox mt={4} display="flex" justifyContent="center">
 <MDBox>
 <TableContainer
    component={Card}
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "150px", 
      height: "auto", 
      padding: "16px",
    }}
  >   
          <Table>
            <TableHead sx={{ mt: 6 }}>
            <TableRow sx={{ backgroundColor:"#2e7faeff" }}> {/* Success Green Color */}
                  <TableCell align="center" sx={{ fontSize: "15px",fontWeight: "bold", color: "white",border: "1px solid #ddd" ,width: "350px" }}>Date</TableCell>
                  <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white" ,width: "350px"}}>Reference Number</TableCell>
                </TableRow>
            
            <TableBody>
              {components.length > 0 ? (
                components.map((item, index) => (
                  <TableRow key={index}>
<TableCell align="center" sx={{ border: "1px solid #ddd", fontSize: "15px" }}>{item.name}</TableCell>
<TableCell  align="center"sx={{ border: "1px solid #ddd",fontSize: "15px" }}>{item.serialnumber}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center">No data available</TableCell>
                </TableRow>
              )}
            </TableBody>
            </TableHead>

          </Table>
        </TableContainer>
         </MDBox>
         </MDBox>
      )}
      {tabValue === 3 && (
    <MDBox mt={4} display="flex" justifyContent="center">
 <MDBox>
 <TableContainer
    component={Card}
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "150px", 
      height: "auto", 
      padding: "16px",
    }}
  >   
          <Table>
            <TableHead sx={{ mt: 6 }}>
            <TableRow sx={{ backgroundColor:"#2e7faeff"   }}> {/* Success Green Color */}
                  <TableCell align="center" sx={{ fontSize: "15px",fontWeight: "bold", color: "white",border: "1px solid #ddd" ,width: "350px" }}>Date</TableCell>
                  <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd" ,width: "350px"}}>Amount</TableCell>
                  {/* <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd" }}>Timestamp</TableCell>
                  <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd" }}>Voltage</TableCell>

                  <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd" }}>Current</TableCell>

                  <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd" }}>Power</TableCell>

                  <TableCell align="center" sx={{fontSize: "15px", fontWeight: "bold", color: "white",border: "1px solid #ddd" }}>Energy</TableCell> */}



                </TableRow>
            
            <TableBody>
              {monitoring.length > 0 ? (
                monitoring.map((item, index) => (
                  <TableRow key={index}>
<TableCell align="center" sx={{ border: "1px solid #ddd", fontSize: "15px" }}>{item.deviceId}</TableCell>
<TableCell  align="center"sx={{ border: "1px solid #ddd",fontSize: "15px" }}>{item.outletId}</TableCell>
<TableCell  align="center"sx={{ border: "1px solid #ddd",fontSize: "15px" }}>{item.timestamp}</TableCell>
<TableCell  align="center"sx={{ border: "1px solid #ddd",fontSize: "15px" }}>{item.voltage}{item.voltageUnit}</TableCell>
<TableCell  align="center"sx={{ border: "1px solid #ddd",fontSize: "15px" }}>{item.current}{item.currentUnit}</TableCell>
<TableCell  align="center"sx={{ border: "1px solid #ddd",fontSize: "15px" }}>{item.power} {item.powerUnit}</TableCell>
<TableCell  align="center"sx={{ border: "1px solid #ddd",fontSize: "15px" }}>{item.energy}{item.energyUnit}</TableCell>


                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">No data available</TableCell>
                </TableRow>
              )}
            </TableBody>
            </TableHead>

          </Table>
          
        </TableContainer>
         </MDBox>
         </MDBox>
      )}
    </Card>
    {/* {openDelearModal && (
      <DeviceMappingModal
        isOpen={openDelearModal}
        onRequestClose={handleCloseDelearModal}
        customerid={id}
        name={name}
        customertypeid={customerid}
      />
    )} */}
     <Modal open={deleteModal} onClose={() => setDeleteModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>Are you sure you want to delete this device type?</Typography>
              <MDButton onClick={handleDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
              <MDButton color="secondary" onClick={() => setDeleteModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
            </Card>
          </Modal>
        </DashboardLayout>
    
  );
};

export default CustomerProfileDetails;
